import React, { useState } from 'react';
//import StripeCheckout from '../components/StripeCheckout';
//import PayPalCheckout from '../components/PaypalCheckout';
import '../styles/CheckoutPage.css';
import { useCart } from '../context/CartContext';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../utils/apiConfig';
//import OrderCountdown from '../components/OrderCountdown';
//import FlatpayCheckout from '../components/FlatpayCheckout';



const formatEuro = (value) =>
    value.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
    });

const parsePrice = (price) => {
    if (typeof price === 'string') return parseFloat(price.replace(',', '.'));
    return price;
};

const calculateTotal = (items) => {
    return items.reduce((total, item) => {
        const price = parsePrice(item.price);
        const quantity = item.quantity || 1;
        return total + price * quantity;
    }, 0).toFixed(2);
};

const CheckoutPage = () => {
    const { t } = useTranslation();
    const { cartItems, total, clearCart } = useCart();
    const [tip, setTip] = useState(0);
    const [tipSubmitted, setTipSubmitted] = useState(false);
    const [confirmation, setConfirmation] = useState(null);
    const [loading, setLoading] = useState(false); // <-- loading state
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isOrderOpen, setIsOrderOpen] = useState(true);
    const API_BASE = getApiBaseUrl();



    const stripeFee = total * 0.014 + 0.25;
    // const totalWithTip = total + tip;
    const totalStripePayment = total + stripeFee + tip;

    const submitTip = async (source, userIdentifier, transactionId) => {
        try {
            const res = await fetch(`${API_BASE}/api/tips/save`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    tipAmount: tip,
                    source,
                    userIdentifier,
                    transactionId,
                }),
            });
            if (res.ok) setTipSubmitted(true);
        } catch (err) {
            console.error('❌ Failed to submit tip', err);
        }
    };
    const submitOrderToPrintServer = async (paymentId, paymentProvider) => {
        setLoading(true);
        const orderPayload = {
            items: cartItems.map(item => ({
                id: item.id,
                code: item.code || '',
                title: item.title || item.name,
                quantity: item.quantity,
                category: item.category,
                variantKey: item.variantKey || null,
                variant: item.variant || null,
                variants: item.variants || null,
                price: item.price,
                note: item.note || '',
            })),
            total: calculateTotal(cartItems),
            timestamp: new Date().toISOString(),
            type: 'Abholung',
            estimatedReadyTime: '15 Min',
            phoneNumber: phoneNumber || '',
            paymentId,
            paymentProvider
        };

        try {
            const res = await fetch(`${API_BASE}/api/order`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(orderPayload),
            });

            const data = await res.json();
            if (res.ok) {
                console.log('✅ Order processed and printed:', data);
                setConfirmation({
                    orderNumber: data.orderNumber,
                    estimatedTime: data.estimatedReadyTime,
                    type: data.type || 'Abholung'
                });
                clearCart();
            } else {
                console.error('❌ Backend rejected order:', data);
                alert(`Error: ${data.error || 'Failed to process order'}`);
            }
        } catch (err) {
            console.error('❌ Error submitting order:', err);
            alert('Error submitting order. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleTipSubmit = async (provider, transactionId, userIdentifier = null) => {
        setLoading(true);
        if (tip > 0 && !tipSubmitted) {
            await submitTip(provider, userIdentifier, transactionId);
        }

        await submitOrderToPrintServer(transactionId, provider);
        setLoading(false);
    };


    return (
        <div className="checkout-wrapper">
            <div className="navbar-spacer" />
            <div className="checkout-container">
                <h1>{t('checkout.title')}</h1>
                {/*
                <OrderCountdown onTimeStatusChange={setIsOrderOpen} />
                <p style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#444', marginBottom: '10px' }}>
                    🚶 {t('checkout.pickupNotice')}
                </p>
                    */}
                {/* Tip Section */}
                {/*
                <div className="tip-section">
                    <h2>💸 {t('checkout.tipQuestion')}</h2>
                    <div className="tip-buttons">
                        {[0, 2, 5, 10].map(val => (
                            <button
                                key={val}
                                onClick={() => setTip(val)}
                                className={tip === val ? 'selected' : ''}
                                disabled={loading} // disable during loading
                            >
                                {val} €
                            </button>
                        ))}
                    </div>
                    <input
                        type="number"
                        min="0"
                        placeholder={t('checkout.customTipPlaceholder')}
                        onChange={(e) => setTip(Number(e.target.value))}
                        style={{ marginTop: '10px', padding: '6px', width: '100px' }}
                        disabled={loading} // disable during loading
                    />
                </div>
                */}

                {/* Phone Number Input */}
                {/*
                <div className="phone-input-section">
                    <label htmlFor="phone">📞 {t('checkout.phoneNumberLabel')}</label>
                    <input
                        id="phone"
                        type="tel"
                        placeholder={t('checkout.phoneNumberPlaceholder')}
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        disabled={loading}
                    />
                </div>
                */}
                {/* Order Summary 
                <div className="order-summary">
                    <h3>🧾 {t('checkout.summary')}</h3>
                    <p><strong>{t('checkout.cart')}:</strong> {formatEuro(total)}</p>
                    <p><strong>{t('checkout.stripeFee')}:</strong> {formatEuro(stripeFee)}</p>
                    <p><strong>{t('checkout.tipOptional')}:</strong> {formatEuro(tip)}</p>
                    <hr />
                    <p><strong>💰 {t('checkout.stripeTotal')}:</strong> {formatEuro(totalStripePayment)}</p>
                   <p><strong>💰 {t('checkout.paypalTotal')}:</strong> {formatEuro(totalWithTip)}</p> 
                    {tipSubmitted && (
                        <p style={{ color: 'green', marginTop: '10px' }}>
                            🎉 {t('checkout.thankYouTip')}
                        </p>
                    )} */}
                {/* Confirmation Screen
                    {confirmation && (
                        <div className="confirmation-screen">
                            <h2>🎉 Vielen Dank für Ihre Bestellung!</h2>
                            <p>🧾 Ihre Bestellnummer: <strong>#{confirmation.orderNumber}</strong></p>
                            <p>⏱️ Abholbereit in: <strong>{confirmation.estimatedTime}</strong></p>
                            <p>📦 Typ: <strong>{confirmation.type}</strong></p>
                            {phoneNumber && (
                                <p>📞 Telefonnummer: <strong>{phoneNumber}</strong></p>
                            )}
                        </div>
                    )}
                </div>
                    */}

                {/*
                {phoneNumber.trim() === '' && (
                    <p style={{ color: 'red', marginBottom: '10px' }}>
                        {t('checkout.enterPhoneToProceed')}
                    </p>
                )}
                */}

                <div
                    className="pickup-message"
                    style={{
                        background: "#fff8e6",
                        border: "2px solid #f4c542",
                        borderRadius: "15px",
                        padding: "25px",
                        marginTop: "30px",
                        textAlign: "center",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                    }}
                >
                    <h2 style={{ marginBottom: "15px" }}>
                        🍽️ Bestellung & Abholung
                    </h2>

                    <p style={{ fontSize: "18px", lineHeight: "1.8" }}>
                        Online-Zahlungen sind derzeit nicht verfügbar.
                    </p>

                    <p style={{ fontSize: "17px", lineHeight: "1.8" }}>
                        Bitte kontaktieren Sie unser Restaurant telefonisch, um Ihre Bestellung aufzugeben.
                    </p>

                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                        📞 +49 030 81098009
                    </p>

                    <p style={{ marginTop: "15px" }}>
                        Nach Ihrer Bestellung können Sie diese direkt im Restaurant abholen.
                    </p>

                    <p>
                        Vielen Dank für Ihren Besuch. Wir freuen uns auf Ihre Bestellung!
                    </p>
                </div>

                {/* Stripe 
                <div className="payment-section">
                    <h2>Stripe</h2>
                    <StripeCheckout
                        amount={totalStripePayment}
                        onSuccess={(transactionId, userIdentifier) =>
                            handleTipSubmit('stripe', transactionId, userIdentifier)
                        }
                        disabled={loading || phoneNumber.trim() === '' || !isOrderOpen} // pass down loading to disable payment button
                    />
                </div> */}

                {/* Flatpay 
                <div className="payment-section">
                    <h2>Flatpay</h2>
                    <FlatpayCheckout
                        amount={totalStripePayment}
                        onSuccess={(transactionId, userIdentifier) =>
                            handleTipSubmit('flatpay', transactionId, userIdentifier)
                        }
                        disabled={loading || phoneNumber.trim() === '' || !isOrderOpen}
                    />
                </div> */}


                {/* PayPal 
                <div className="payment-section">
                    <h2>PayPal</h2>
                    <PayPalCheckout
                        amount={totalWithTip}
                        onSuccess={(transactionId, userIdentifier) =>
                            handleTipSubmit('paypal', transactionId, userIdentifier)
                        }
                        disabled={loading || phoneNumber.trim() === '' || !isOrderOpen}  // pass down loading to disable payment button
                    />
                </div> */}

                {/* Loading indicator */}
                {loading && (
                    <div className="loading-overlay">
                        <p>⏳ {t('checkout.processingPayment')}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CheckoutPage;
